module.exports = __webpack_public_path__ + "static/media/17.9863fa10.jpeg";